export class AddProposalDto {
    name!: string;
    timestampStart: Date;
    timestampEnd: Date;
}